import React, { useContext, useEffect, useRef } from "react";
import ResultDetails from "./Details/ResultDetails.jsx";
import ResultDetailsNba from "./Details/ResultDetailsNba.jsx";
import ResultDetailsTTT from "./Details/ResultDetailsTTT.jsx";
import ResultDetailsTeams from "./Details/ResultDetailsTeams.jsx";
import ResultDetailsTournament from "./Details/ResultDetailsTournament.jsx";
import ResultDetailsQualifier from "./Details/ResultDetailsQualifier.jsx";
import { IsMobileContext } from "../isMobileContext";

const resultPartsToShow = [
    "result-part--team-time-trial",
    "result-part--places",
    "result-part--tournament",
    "result-part--nba",
    "result-part--team-places",
    "result-part--qualifications",
];

const ResultGeneric = ({result, marked, onDetailsClick, current, game}) => {

    const element = useRef(null);
    const ctx = useContext(IsMobileContext);

    useEffect(() => {
        if(element.current && marked && marked.length > 0 && ctx.isMobile){
            window.scrollTo({
                top: element.current.offsetTop,
                behavior: "smooth",
              });
        }
    }, [marked]);


    if (!result) return null;

    let parts = result.parts.filter((part) =>
        resultPartsToShow.includes(part.type)
    );

    if (!parts.length) {
        return null;
    }

    if (result.showResultGeneric === false) {
        return null;
    }

    let hasShootout = false;
    if (
        typeof result.parts[0] !== 'undefined' &&
        typeof result.parts[0].details !== 'undefined' &&
        typeof result.parts[0].details[0] !== 'undefined' &&
        typeof result.parts[0].details[0].hasShootout !== 'undefined' &&
        result.parts[0].details[0].hasShootout === true
    ) {
        hasShootout = true;
    }

    // CLASS NAME:
    // match-calendar
    // result ->
    return (
        <div ref={element} className="match-calendar">
            <Panel name={result.title}>
                {parts.map((part) => (
                    <ResultPart
                        key={part.type}
                        {...part}
                        marked={marked}
                        onDetailsClick={onDetailsClick}
                        hasShootout={hasShootout}
                        current={current}
                        result={result}
                        game={game}
                    />
                ))}
            </Panel>
        </div>
    );
};

const ResultPart = ({type, details, marked, onDetailsClick, hasShootout, current, result, game, ...rest}) => {
    switch (type) {
        case "result-part--team-time-trial":
            return <ResultDetailsTTT {...rest} />;
        case "result-part--places":
            return (
                <ResultDetails
                    onDetailsClick={onDetailsClick}
                    details={details}
                    marked={marked}
                />
            );
        case "result-part--tournament":
            return (
                <ResultDetailsTournament
                    onDetailsClick={onDetailsClick}
                    details={details}
                    marked={marked}
                    current={current}
                    result={result}
                    game={game}
                />
            );
        case "result-part--nba":
            return (
                <ResultDetailsNba
                    onDetailsClick={onDetailsClick}
                    details={details}
                    marked={marked}
                    hasShootout={hasShootout}
                    current={current}
                    result={result}
                    game={game}
                />
            );
        case "result-part--team-places":
            return <ResultDetailsTeams details={details} marked={marked}/>;
        case "result-part--qualifications":
            return <ResultDetailsQualifier details={details} marked={marked}/>;
        default:
            return null;
    }
};

const Panel = ({name, children}) => (
    <section className="module">
        <header className="module__header">
            <h2 className="module__title">{name}</h2>
        </header>
        {children}
    </section>
);

export default ResultGeneric;
